import {
  EMPTY_STRING,
  globalConstants,
  privacyPolicyConstants,
} from "../../constants";

const { GET_PRIVACY_POLICY } = privacyPolicyConstants;
const { SUCCESS } = globalConstants;

const initialState = {
  privacyPolicy: EMPTY_STRING,
};

export const privacyPolicyReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PRIVACY_POLICY + SUCCESS:
      return { ...state, privacyPolicy: action.data };
    default:
      return { ...state };
  }
};
